// src/infra/FrotaApi.js — monitor da frota (iot-hub /api/fleet, só ADMIN)
import api from './axios';

const PREFIX = '/iot-hub/api/fleet';

/** Frota inteira: torres + cliente + presença + alertas, resumo e estado do monitor. */
export const getFrota = () => api.get(PREFIX).then((r) => r.data);

/** Uma torre e o histórico de alertas dela. */
export const getTorre = (serial) =>
    api.get(`${PREFIX}/devices/${encodeURIComponent(serial)}`).then((r) => r.data);

/** Alertas filtrados por status (lista) e/ou serial. */
export const listarAlertas = ({ status = [], serial, limite } = {}) =>
    api
        .get(`${PREFIX}/alerts`, {
            params: {
                status: status.length ? status.join(',') : undefined,
                serial: serial || undefined,
                limite: limite || undefined,
            },
        })
        .then((r) => r.data ?? []);

/** Contagem leve para o contador do menu. */
export const getResumoAlertas = () => api.get(`${PREFIX}/alerts/resumo`).then((r) => r.data);

/** "Estou vendo": o alerta continua ativo até a condição sumir. */
export const reconhecerAlerta = (id) =>
    api.post(`${PREFIX}/alerts/${encodeURIComponent(id)}/ack`).then((r) => r.data);
